/* tslint:disable */
/* eslint-disable */
export enum EnumReponseStateMessageType {
  Warning = 'Warning',
  Exception = 'Exception'
}
